export class UniqueIdGenerator {
    private static counter = 0;

    public static generateId(
        str: string,
        ...properties: (string | number)[]
    ): string {
        if (!str) {
            throw new Error('String should not be null, undefined or empty.');
        }

        UniqueIdGenerator.counter = (UniqueIdGenerator.counter + 1) % 1000000;
        const uniqueTimestamp = `${Date.now()}-${UniqueIdGenerator.counter.toString().padStart(6, '0')}`;

        const uniqueID = btoa(
            unescape(encodeURIComponent(str + uniqueTimestamp))
        );
        if (!properties || properties.length === 0) {
            return uniqueID;
        }

        return properties.reduce<string>((acc, cur): string => {
            const stringProperty = typeof cur === 'string' ? cur : `${cur}`;

            if (!stringProperty) {
                return '';
            }

            return acc + btoa(stringProperty);
        }, uniqueID);
    }
}
